import { BusinessRuleRamoService } from './../../shared/services/business-rule-ramo.service';
import { Location } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import {
  IDynamicComponent,
  IDynamicComponentItem,
  ILineaNegocio,
  IProducto,
} from 'src/app/shared/Entities/entities';
import { ProductService } from 'src/app/shared/services/product.service';
import { IMenuItem } from './../../shared/Entities/entities';
import { key_user_info, productosPath } from './../../shared/helpers/constants';
import { EventsService } from './../../shared/services/events.service';
import { ProductoIndividualService } from 'src/app/shared/services/producto-individual.service';
import { DocumentManagementService } from 'src/app/shared/services/document-management.service';
import { getLocalStorage } from 'src/app/shared/helpers/helper';
import { PopUpFirma } from '../pop-up-firma/pop-up-firma';
import { MatDialog } from '@angular/material/dialog';
import { DynamicComponentService } from '@app/shared/services/dynamicComponent.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-productos',
  templateUrl: './productos.component.html',
  styleUrls: ['./productos.component.sass'],
})
export class ProductosComponent implements OnInit, OnDestroy {
  // lineaNegocioBehavior: Observable<ILineaNegocio[]>;
  segurosIndivuales: IProducto[] = [];
  segurosColectivos: IProducto[] = [];
  segurosVitalicios: IProducto[] = [];
  segurosPrivados: IProducto[] = [];
  segurosSalud: IProducto[] = [];
  optionSafe = '';
  componentesDinamicos: IDynamicComponent = undefined;
  componentList: IDynamicComponentItem[] = [];
  showBanner: boolean = false;
  bannerTitle: string = '';
  bannerDescription: string = '';
  redirectBanner: string = '';
  modalTitle: string = '';
  modalDescription: string = '';
  errorModalLabel: string = 'Aceptar';
  redirectModal: string = '';
  cancelButton: boolean = true;
  showModal: boolean = false;
  private subscriptions: Subscription[] = [];

  menuItems: IMenuItem[] = [];

  modalComponentesDinamicosBiceVisible: boolean =
    `${environment.modalComponentesDinamicosBiceVisible}` === 'true'
      ? true
      : false;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    private productService: ProductService,
    private productIndividualService: ProductoIndividualService,
    private eventsSrv: EventsService,
    private businessRule: BusinessRuleRamoService,
    private location: Location,
    private documentManagementService: DocumentManagementService,
    private dynamicComponentService: DynamicComponentService,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    const userInfo = getLocalStorage(key_user_info);
    this.documentManagementService.GetDocument('CONVENIO').subscribe(
      res => {
        const document = res.documents.find(x => (x.name = 'AUSAD'));
        this.documentManagementService
          .DocumentSignature(
            document.id,
            userInfo.rut.split('-').join(''),
            'last'
          )
          .subscribe(
            () => {
              console.log('Firma Convenio Registrada');
            },
            () => this.dialog.open(PopUpFirma)
          );
      },
      error => {
        console.log(error);
      }
    );

    this.productIndividualService
      .validarClienteAhorro()
      .subscribe(dataAhorro => {
        this.eventsSrv.setVisibilityInforme(dataAhorro ? true : false);
      });
    const lneaNegocioSubscription = this.productService
      .listarLineaNegocio()
      .subscribe(
        data => {
          this.segurosIndivuales = this.getProducts(data, 'SEGURO INDIVIDUAL');
          this.segurosColectivos = this.getProducts(data, 'SEGURO COLECTIVO');
          this.segurosVitalicios = this.getProducts(
            data,
            'RENTAS VITALICIAS'
          ).filter(d => d.Codigo !== 'PRIV');
          this.segurosPrivados = this.getProducts(
            data,
            'RENTAS VITALICIAS'
          ).filter(d => d.Codigo === 'PRIV');
          this.segurosSalud = this.getProducts(data, 'SEGURO SALUD');

          const lineasNegocio = data.map(ln => ln.LineaNegocio);
          if (this.modalComponentesDinamicosBiceVisible) {
            this.loadDynamicComponents(userInfo, lineasNegocio);
          }

          this.eventsSrv.setVisibilityPagarProducto(
            this.businessRule.showPagarMisProductos(
              this.segurosIndivuales.map(s => s.Codigo)
            )
          );

          // this.productService
          //   .getResumen(this.segurosIndivuales.map(x => x.Poliza))
          //   .subscribe(resumen => {
          //     if (this.businessRule.showPagarMisProductos(resumen.CodigoRamo)) {
          //       this.eventsSrv.setVisibilityPagarProducto(true);
          //     }
          //   });

          console.log(this.segurosColectivos);

          this.productService
            .getResumenColectivoMap(this.segurosColectivos.map(x => x.Poliza))
            .subscribe(
              resumenColectivo => {
                const seguroColectivo = this.segurosColectivos.find(
                  x => x.Poliza === resumenColectivo.NumeroPoliza
                );
                seguroColectivo.Nombre = resumenColectivo.NombreFantasia;
                if (resumenColectivo.Coberturas.indexOf('SALUD COVID') !== -1) {
                  seguroColectivo.Nombre = 'SEGURO INDIVIDUAL COVID';
                  seguroColectivo.PolizaDescripcion =
                    String(resumenColectivo.NumeroPoliza) +
                    '-' +
                    String(resumenColectivo.CodigoAsegurado);
                }
              },
              error => {
                this.setMenu();
                this.redirect();
              },
              () => {
                this.setMenu();
                this.redirect();
              }
            );
        },
        this.productService.changeOptionSafe.subscribe((option: string) => {
          this.optionSafe = option;
        })
      );
    this.subscriptions.push(lneaNegocioSubscription);
  }

  mapBusinessLine(lineaNegocio: string): string {
    const mapping = {
      'SEGURO INDIVIDUAL': 'INDIVIDUAL',
      'SEGURO COLECTIVO': 'COLLECTIVE',
      'RENTAS VITALICIAS': 'PENSION',
      'SEGURO SALUD': 'MASSIVE',
    };
    return mapping[lineaNegocio] || lineaNegocio;
  }

  loadDynamicComponents(userInfo: any, lineasNegocio: string[]) {
    const businessLine = lineasNegocio
      .map(ln => this.mapBusinessLine(ln))
      .filter((value, index, self) => self.indexOf(value) === index)
      .join(',');

    const allPolicies = this.segurosIndivuales
      .map(p => p.PolizaDescripcion || p.Poliza + '-x')
      .concat(
        this.segurosColectivos.map(p => p.PolizaDescripcion || p.Poliza + '-x')
      )
      .concat(
        this.segurosVitalicios.map(p => p.PolizaDescripcion || p.Poliza + '-x')
      )
      .concat(
        this.segurosPrivados.map(p => p.PolizaDescripcion || p.Poliza + '-x')
      )
      .concat(
        this.segurosSalud.map(p => p.PolizaDescripcion || p.Poliza + '-x')
      )
      .filter(p => p)
      .join(',');

    const dynamicComponentInfo = this.dynamicComponentService
      .obtenerComponentesDinamicos(
        userInfo.rut.split('-').join(''),
        businessLine,
        allPolicies
      )
      .subscribe(response => {
        this.componentesDinamicos = response;
        if (
          response.httpCode == 200 &&
          response.componentes &&
          response.componentes.componentList.length > 0
        ) {
          this.componentList = this.componentesDinamicos.componentes.componentList;
          const bannerComponent = this.componentList.find(
            c => c.type === 'webBanner'
          );
          if (bannerComponent) {
            this.bannerTitle =
              bannerComponent.data.title || 'Error de conexión';
            this.bannerDescription =
              bannerComponent.data.description ||
              'El servicio BICE no entregó datos. Por favor, intente nuevamente.';
            this.redirectBanner =
              bannerComponent.data.redirectButton.link || '';
            this.showBanner = true;
          }
          const modalComponent = this.componentList.find(
            c => c.type === 'modal'
          );
          if (modalComponent) {
            this.modalTitle = modalComponent.data.title || 'Error de conexión';
            this.modalDescription =
              modalComponent.data.description ||
              'El servicio BICE no entregó datos. Por favor, intente nuevamente.';
            this.redirectModal = modalComponent.data.primaryButton.link || '';
            this.cancelButton = modalComponent.data.cancelButton ? true : false;
            this.showModal = true;
          }
        } else {
          this.showModal = false;
          this.showBanner = false;
        }
      });
  }

  redirect() {
    if (this.location.path() !== '/productos') {
      return;
    }
    if (this.segurosColectivos.length > 0) {
      this.menuItems.find(x => x.route.path === 'colectivo').active = true;
      this.router.navigate(['colectivo'], { relativeTo: this.route });
    } else if (this.segurosIndivuales.length > 0) {
      this.menuItems.find(x => x.route.path === 'individual').active = true;
      this.router.navigate(['individual'], { relativeTo: this.route });
    } else if (this.segurosVitalicios.length > 0) {
      this.menuItems.find(x => x.route.path === 'vitalicio').active = true;
      this.router.navigate(['vitalicio'], { relativeTo: this.route });
    } else if (this.segurosSalud.length > 0) {
      this.menuItems.find(x => x.route.path === 'salud').active = true;
      this.router.navigate(['salud'], { relativeTo: this.route });
    } else {
      this.menuItems.find(x => x.route.path === 'privado').active = true;
      this.router.navigate(['privado'], { relativeTo: this.route });
    }
  }

  setMenu() {
    Object.keys(productosPath.children).forEach(e => {
      switch (e) {
        case productosPath.children.individual.path:
          if (this.segurosIndivuales.length !== 0) {
            const arr: IMenuItem[] = this.segurosIndivuales.map(s => {
              return {
                id: s.Poliza,
                label: s.Nombre,
                route: productosPath.children.individual.children.detalle,
                item: s,
              };
            });
            this.menuItems.push({
              route: productosPath.children[e],
              children: arr,
            });
          }
          break;
        case productosPath.children.colectivo.path:
          if (this.segurosColectivos.length !== 0) {
            const arr: IMenuItem[] = this.segurosColectivos.map(s => {
              return {
                id: s.Poliza,
                label: s.Nombre,
                route: productosPath.children.colectivo.children.detalle,
                item: s,
              };
            });
            this.menuItems.push({
              route: productosPath.children[e],
              children: arr,
            });
          }
          break;

        case productosPath.children.vitalicio.path:
          if (this.segurosVitalicios.length !== 0) {
            const arr: IMenuItem[] = this.segurosVitalicios.map(s => {
              return {
                id: s.Poliza,
                label: s.Nombre,
                route: productosPath.children.vitalicio.children.detalle,
                item: s,
              };
            });
            this.menuItems.push({
              route: productosPath.children[e],
              children: arr,
            });
          }
          break;
        case productosPath.children.privado.path:
          if (this.segurosPrivados.length !== 0) {
            const arr: IMenuItem[] = this.segurosPrivados.map(s => {
              return {
                id: s.Poliza,
                label: s.Nombre,
                route: productosPath.children.privado.children.detalle,
                item: s,
              };
            });
            this.menuItems.push({
              route: productosPath.children[e],
              children: arr,
            });
          }
          break;

        // RDP: Para salud
        case productosPath.children.salud.path:
          if (this.segurosSalud.length !== 0) {
            const arr: IMenuItem[] = this.segurosSalud.map(s => {
              return {
                id: s.Poliza,
                label: s.Nombre,
                route: productosPath.children.salud.children.detalle,
                item: s,
              };
            });
            this.menuItems.push({
              route: productosPath.children[e],
              children: arr,
            });
          }
          break;

        default:
          break;
      }
    });

    this.eventsSrv.setMenu(this.menuItems);
  }

  getProducts(data: ILineaNegocio[], lineaNegocio) {
    const lista = data.find(d => d.LineaNegocio === lineaNegocio);
    if (!lista) {
      return [];
    }

    return lista.ListaProductos.Producto;
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  onRequest() {
    if (this.redirectModal) {
      const url =
        this.redirectModal.startsWith('http://') ||
        this.redirectModal.startsWith('https://')
          ? this.redirectModal
          : 'https://' + this.redirectModal;
      window.location.href = url;
    }
    this.errorModalLabel = 'Cargando...';
  }

  closeErrorModal() {
    this.showModal = false;
  }
}
